var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4665 21.2653L28.7905 17.6573C28.955 17.5645 29.0919 17.4297 29.1873 17.2667C29.2826 17.1037 29.333 16.9182 29.3332 16.7293V9.51334C29.3332 9.32423 29.283 9.13852 29.1876 8.97521C29.0923 8.81191 28.9552 8.6769 28.7905 8.584L22.4665 4.976C22.3008 4.88279 22.1139 4.83382 21.9238 4.83382C21.7337 4.83382 21.5468 4.88279 21.3812 4.976L15.0558 8.584C14.8914 8.67707 14.7546 8.81216 14.6595 8.97545C14.5644 9.13874 14.5143 9.32436 14.5145 9.51334V22.408L10.0785 24.9373L5.63984 22.4067V17.348L10.0758 14.8187L13.0012 16.488V13.0947L10.6185 11.7347C10.4528 11.6415 10.2659 11.5925 10.0758 11.5925C9.88574 11.5925 9.69885 11.6415 9.53317 11.7347L3.20784 15.3427C3.04318 15.4358 2.90626 15.5711 2.81114 15.7347C2.71601 15.8982 2.66609 16.0841 2.66651 16.2733V23.4893C2.66651 23.8707 2.87317 24.2253 3.20917 24.4173L9.53451 28.0253C9.70018 28.1185 9.88707 28.1675 10.0772 28.1675C10.2673 28.1675 10.4542 28.1185 10.6198 28.0253L16.9452 24.4173C17.1094 24.3244 17.2461 24.1895 17.3412 24.0265C17.4363 23.8634 17.4864 23.6781 17.4865 23.4893V10.592L17.5665 10.548L21.9212 8.064L26.3572 10.592V15.652L21.9198 18.18L18.9985 16.516V19.9093L21.3772 21.2653C21.5428 21.3586 21.7297 21.4075 21.9198 21.4075C22.1099 21.4075 22.2968 21.3586 22.4625 21.2653H22.4665Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygon);
export default __webpack_public_path__ + "static/media/icon-polygon.3b21ecd4cde50841d588f309301afcf6.svg";
export { ForwardRef as ReactComponent };